/**
 * Auth API Client Hook — Identity Frontend
 *
 * Registers the OIDC token provider with the base API client
 * so authenticated requests include the Bearer token automatically.
 */

import { useEffect } from "react";
import { setAuthTokenProvider } from "../api/client";
import { useAuth } from "./useAuth";

export const useAuthApiClient = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      const tokenProvider = async () => {
        try {
          const token = await getAccessTokenSilently();
          if (!token) {
            throw new Error("Token is empty");
          }
          return token;
        } catch (error) {
          console.error("[useAuthApiClient] Failed to get token:", error);
          throw error;
        }
      };

      setAuthTokenProvider(tokenProvider);

      if (import.meta.env.DEV) {
        console.log("[useAuthApiClient] Token provider registered");
      }
    } else if (!isLoading && !isAuthenticated) {
      const errorProvider = async () => {
        throw new Error("User not authenticated");
      };
      setAuthTokenProvider(errorProvider);
    }
  }, [isAuthenticated, isLoading, getAccessTokenSilently]);
};

export default useAuthApiClient;
